/*         */
import { defineRoute } from "@kestrel/router";
/*         */
import type { LoadContext, Params } from "@kestrel/server";

export const routes = [
    defineRoute({
        path: "/trend",
        component: () => import("./cinemas/StorefrontTrendCinema.svelte"),
        server: () => import("./cinemas/StorefrontTrendCinema.server.ts"),
    }),
    defineRoute({
        path: "/lastseen",
        component: () => import("./cinemas/LastSeenArticlesCinema.svelte"),
        server: () => import("./cinemas/LastSeenArticlesCinema.server.ts"),
    }),
    defineRoute({
        path: "/entrypage",
        component: () => import("./cinemas/EntryPageCinema.svelte"),
        server: () => import("./cinemas/EntryPageCinema.server.ts"),
    }),
    defineRoute({
        path: "/storefront",
        component: () => import("./cinemas/StorefrontCinema.svelte"),
        server: () => import("./cinemas/StorefrontCinema.server.ts"),
    }),
    defineRoute({
        path: "/basket",
        component: () => import("./cinemas/BasketCinema.svelte"),
        server: () => import("./cinemas/BasketCinema.server.ts"),
    }),
    defineRoute({
        path: "/trend/health",
        methods: {
            GET(_: Params, ctx: LoadContext) {
                ctx.json({ status: 200, body: JSON.stringify({ status: "ok" }) });
            }
        }
    }),
    defineRoute({
        path: '/internal/prometheus',
        methods: () => import('./services/observability/Prometheus.ts')
    })
];
